import { HttpEvent, HttpHandler, HttpInterceptor, HttpInterceptorFn, HttpRequest } from '@angular/common/http';
import { finalize, Observable } from 'rxjs';
import { LoaderService } from '../services/loader.service';
import { Injectable } from '@angular/core';

@Injectable()
export class LoaderInterceptor implements HttpInterceptor {

  private excludedEndPoints = ['download-merged', 'download-reserved'];

  constructor(private loaderService: LoaderService) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    console.log('HTTP Request intercepted:', req.url); // Debug log

    const shouldExclude = this.excludedEndPoints.some(endpoint => req.url.includes(endpoint));
    if (!shouldExclude) {
      this.loaderService.show();
    }
    
    return next.handle(req).pipe(
      finalize(() => {
        // console.log('HTTP Request finalized:', req.url); // Debug log
        this.loaderService.hide();
      })
    );
  }
}
